<template>
  <v-container
    fill-height
    justify-content-start
    :class="{ 'px-7 pt-5': $vuetify.breakpoint.xsOnly }"
    class="section-width pb-0"
  >
    <v-layout column>
      <date-buttons :numberOfDaysToDisplay="daysToDisplay" @change="value => selectedDay = value"/>

      <category-filtering @selectedCategories="setSelectedCategories"/>

      <v-layout column class="app-scroll-section section-margins">
        <div
          class="justify-center margin-on-children"
          v-if="displayEvents.length > 0 || loading"
          style="overflow-y: scroll; -webkit-overflow-scrolling: touch"
        >
          <v-layout v-if="displayEvents.length" row wrap class="my-0">
            <v-flex
              xs12
              md6
              v-for="(event, i) in displayEvents"
              :key="i"
              class="my-2 margin-on-last-child"
              style="max-height: 128px;"
            >
              <upcoming-event
                :event="event"
                :class="{'mx-1': $vuetify.breakpoint.smAndUp }"
              />
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="primary darken-1"
              class="my-2"
            ></v-progress-circular>
          </v-layout>
        </div>
        <v-layout v-else-if="!upcomingEvents.length" column justify-center align-center class="H1 grey-1--text pt-7 ml-3">
          {{ $t("upcoming_events.no_events") }}
        </v-layout>
        <v-layout v-else column justify-center align-center class="H1 grey-1--text pt-7 ml-3">
          {{ $t("upcoming_events.no_events_today") }}
        </v-layout>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import routingMixins from '@/mixins/Routing'

export default {
  data () {
    return {
      tab: null,
      loading: false,
      daysToDisplay: 5,
      selectedDay: null,
      moment,
      selectedCategories: localStorage.getItem('upcomingEventCategories') ? JSON.parse(localStorage.getItem('upcomingEventCategories')) : [],
    }
  },
  components: {
    UpcomingEvent: () => import('@/components/view-components/webapp-pages/upcoming-events/UpcomingEventDetails.vue'),
    CategoryFiltering: () => import('@/components/view-components/webapp-pages/upcoming-events/CategoryFiltering.vue'),
    DateButtons: () => import('@/components/view-components/webapp-pages/page-objects/DateButtons.vue'),
  },
  created () {
    this.getUpcomingEvents()
  },
  computed: {
    ...mapState({
      upcomingEvents: state => state.pages.upcomingEvents,
    }),
    ...mapGetters({
      getDashboardName: 'service/getDashboardName',
    }),
    displayEvents () {
      return this.upcomingEvents.filter((event) => {
        return event.date === this.selectedDay
      })
    },
  },
  methods: {
    getUpcomingEvents () {
      this.$store.dispatch('pages/getOpeningHours', {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().add(this.daysToDisplay - 1, 'd').format('YYYY-MM-DD'),
        activityCategoryIds: this.selectedCategories,
      }).then(() => {
      }).finally(() => {
        this.loading = false
      })
    },
    setSelectedCategories (categories) {
      this.selectedCategories = categories
    },
  },
  watch: {
    selectedCategories () {
      this.getUpcomingEvents()
    },
  },
  mixins: [
    routingMixins,
  ],
}
</script>

<style lang="scss"></style>
